module.exports = __webpack_public_path__ + "static/sketch@2x-d413e699e6320e86e4ecd99bcb94f69a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/labs/sketch@2x.jpg
// module id = 2657
// module chunks = 134932258599989